import { FC } from 'react';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import cssVariables from 'src/styles/_commonVariables.module.scss';
import { CommonRichText, WebpImage } from 'components/Shared/SharedComponents';
import { Block, ImageWrapper } from 'src/__generated__/graphqlTypes';
import { RichTextParsersConfig } from 'types/objectTypes';
import { mapSmallText } from 'lib/richTextMappers';
import classes from 'src/styles/_commonClasses.module.scss';

import styles from './MultipleItemsSlider.module.scss';

interface ItemProps {
  item: Block;
}

const parsersConfigSmall: RichTextParsersConfig = {
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.title,
    mapper: mapSmallText,
  },
  [MARKS.BOLD]: {
    classNames: classes.textBold,
  },
};

const parsersConfigContent: RichTextParsersConfig = {
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.paragraph,
  },
  [BLOCKS.HEADING_2]: {
    classNames: styles.title,
  },
  [BLOCKS.HEADING_3]: {
    classNames: styles.title,
  },
};

const Image: FC<Required<ItemProps>> = ({ item }) => {
  if (item.image) {
    return (
      <WebpImage
        additionalProps={{
          w: 350,
        }}
        widthLimit={[{
          width: 400,
          media: `(min-width: ${cssVariables.mobileViewMaxWidth}px)`,
        },
        {
          width: 340,
          media: `(max-width: ${cssVariables.commonTabletMaxWidth}px)`,
        },
        ]}
        loading="lazy"
        image={item.image}
        className={styles.image}
      />
    );
  }

  const [left, right] = (item.imagesCollection?.items || []) as Array<ImageWrapper>;

  return (
    <div className={styles.imageWrapper}>
      {left?.image && (
        <WebpImage
          image={left.image}
          className={styles.image}
        />
      )}
      {right?.image && (
        <WebpImage
          image={right.image}
          className={styles.image}
        />
      )}
    </div>
  );
};

/* Main Component */
const Item: FC<ItemProps> = ({ item }) => {
  if (!item) {
    return null;
  }

  return (
    <>
      <div className={styles.itemTopContent}>
        <Image item={item} />
        <CommonRichText content={item.richTitle} parsersConfig={parsersConfigSmall} />
      </div>
      <CommonRichText content={item.content} parsersConfig={parsersConfigContent} />
    </>
  );
};

export default Item;
